import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

import { CssBaseline } from "@mui/material";
import { BrowserRouter } from "react-router-dom";

import "./assets/i18n";
import App from "./App";

const container = document.getElementById("root")!;
const root = createRoot(container);

console.log('BFF Authentication Mode initialized');
console.log("BFF Configuration loaded", new Date().toISOString());

root.render(
  <React.Fragment>
    <CssBaseline />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.Fragment>
);

reportWebVitals();